/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubIvcWaybillVo } from './SubIvcWaybillVo';
import {
    SubIvcWaybillVoFromJSON,
    SubIvcWaybillVoFromJSONTyped,
    SubIvcWaybillVoToJSON,
    SubIvcWaybillVoToJSONTyped,
} from './SubIvcWaybillVo';

/**
 * 
 * @export
 * @interface BatchUploadIvcCodeVo
 */
export interface BatchUploadIvcCodeVo {
    /**
     * 主运单号
     * @type {string}
     * @memberof BatchUploadIvcCodeVo
     */
    ivc?: string;
    /**
     * 运输公司编码
     * @type {string}
     * @memberof BatchUploadIvcCodeVo
     */
    transportCompanyCode?: string;
    /**
     * 车牌号（出库方式为货车时必填，此时不登记运单号）
     * @type {string}
     * @memberof BatchUploadIvcCodeVo
     */
    outboundTruckNumber?: string;
    /**
     * 联系方式（出库方式为货车时必填，此时不登记运单号）
     * @type {string}
     * @memberof BatchUploadIvcCodeVo
     */
    outboundTruckContact?: string;
    /**
     * 子单号信息列表，修改运单号要回传id，新增不需要
     * @type {Array<SubIvcWaybillVo>}
     * @memberof BatchUploadIvcCodeVo
     */
    subIvcWaybillVOList?: Array<SubIvcWaybillVo>;
}

/**
 * Check if a given object implements the BatchUploadIvcCodeVo interface.
 */
export function instanceOfBatchUploadIvcCodeVo(value: object): value is BatchUploadIvcCodeVo {
    return true;
}

export function BatchUploadIvcCodeVoFromJSON(json: any): BatchUploadIvcCodeVo {
    return BatchUploadIvcCodeVoFromJSONTyped(json, false);
}

export function BatchUploadIvcCodeVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchUploadIvcCodeVo {
    if (json == null) {
        return json;
    }
    return {
        
        'ivc': json['ivc'] == null ? undefined : json['ivc'],
        'transportCompanyCode': json['transportCompanyCode'] == null ? undefined : json['transportCompanyCode'],
        'outboundTruckNumber': json['outboundTruckNumber'] == null ? undefined : json['outboundTruckNumber'],
        'outboundTruckContact': json['outboundTruckContact'] == null ? undefined : json['outboundTruckContact'],
        'subIvcWaybillVOList': json['subIvcWaybillVOList'] == null ? undefined : ((json['subIvcWaybillVOList'] as Array<any>).map(SubIvcWaybillVoFromJSON)),
    };
}

export function BatchUploadIvcCodeVoToJSON(json: any): BatchUploadIvcCodeVo {
    return BatchUploadIvcCodeVoToJSONTyped(json, false);
}

export function BatchUploadIvcCodeVoToJSONTyped(value?: BatchUploadIvcCodeVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ivc': value['ivc'],
        'transportCompanyCode': value['transportCompanyCode'],
        'outboundTruckNumber': value['outboundTruckNumber'],
        'outboundTruckContact': value['outboundTruckContact'],
        'subIvcWaybillVOList': value['subIvcWaybillVOList'] == null ? undefined : ((value['subIvcWaybillVOList'] as Array<any>).map(SubIvcWaybillVoToJSON)),
    };
}

